function FirebaseAIGroupChat (options) {
	self = this;

	self.cachedAccessToken = {
		access_token: "",
		cacheTime: KJUR.jws.IntDate.get("now")
	};

	self.eventName = "";
	self.beforeSendFunc = "";
	self.successFunc = "";
	self.errorFunc = "";
	self.message = "";

	self.settings = $.extend({
		firebaseAPIKey: "",
		dialogflowSessionId: Math.floor(Math.random() * 1000000),
		dialogflowLang: "en",
		dialogflowAccessToken: "",
		dialogflowBaseUrl: "https://dialogflow.googleapis.com/v2",
		projectId: ""
	}, options );

	// self.url = "https://cors-anywhere.herokuapp.com/" + self.settings.dialogflowBaseUrl + "/projects/symbiosyschat2-ggtwhb/agent/sessions/" + self.settings.dialogflowSessionId + ":detectIntent";
	self.url = self.settings.dialogflowBaseUrl + "/projects/symbiosyschat2-ggtwhb/agent/sessions/" + self.settings.dialogflowSessionId + ":detectIntent";

	self.getDFResponse = function(message, beforeSendFunc, successFunc, errorFunc) {
		// console.log("in getDFResponse");
		self.message = message;
		self.beforeSendFunc = beforeSendFunc;
		self.successFunc = successFunc;
		self.errorFunc = errorFunc;
		$.when(requestAccessToken()).then(getDFResponseAjax);
		
	}

	function getDFResponseAjax(responseData){
		// var propValue;
		// for(var propName in responseData) {
		//     propValue = responseData[propName]

		//     console.log(propName,propValue);
		// }
		self.cachedAccessToken.access_token = responseData.access_token;
		self.cachedAccessToken.cacheTime = KJUR.jws.IntDate.get("now");
		
		$.ajax({
			type: "POST",
			url: self.url,
			contentType: "application/json;",
			dataType: "json",
			crossDomain: true,
			global: false,
			headers: {
				"Authorization": "Bearer " + self.cachedAccessToken.access_token
			},
			data: JSON.stringify({
				"queryInput": 
					{ "text": 
						{ "text": self.message, 
							"languageCode": self.settings.dialogflowLang 
						} 
					},
			}),
			beforeSend: function(){self.beforeSendFunc()},
			success: function(data){self.successFunc(data)},
			error: function(data){self.errorFunc(data)}
		});
	}

	self.triggerDFEvent = function(eventName, beforeSendFunc, successFunc, errorFunc) {
		self.eventName = eventName;
		self.beforeSendFunc = beforeSendFunc;
		self.successFunc = successFunc;
		self.errorFunc = errorFunc;

		$.when(requestAccessToken()).then(triggerDFEventAjax);
		
	}

	function triggerDFEventAjax(responseData){
		// var propValue;
		// for(var propName in responseData) {
		//     propValue = responseData[propName]

		//     console.log(propName,propValue);
		// }
		self.cachedAccessToken.access_token = responseData.access_token;
		self.cachedAccessToken.cacheTime = KJUR.jws.IntDate.get("now");
		// console.log("cachedAccessToken:" + self.cachedAccessToken.access_token);
		
		return $.ajax({
			type: "POST",
			url: self.url,
			contentType: "application/json;",
			dataType: "json",
			crossDomain: true,
			global: false,
			headers: {
				"Authorization": "Bearer " + self.cachedAccessToken.access_token
			},
			data: JSON.stringify({
			  "queryInput": {
			    "event": {
			      "name": self.eventName,
			      "languageCode": "en"
			    }
			  }
			}),
			beforeSend: function(){self.beforeSendFunc},
			success: function(data){self.successFunc(data)},
			error: function(data){self.errorFunc(data)}
		});
	}

	function _genJWS() {
	    var header = '{"alg":"RS256","typ":"JWT", "kid":"4876cd1c659762f5163ed38c844f3dcabdac3c10"}';
	    var claimSet = '{"iss": "dialogflow-syciui@symbiosyschat2-ggtwhb.iam.gserviceaccount.com", "sub": "dialogflow-syciui@symbiosyschat2-ggtwhb.iam.gserviceaccount.com", "scope": "https://www.googleapis.com/auth/dialogflow", "aud":"https://www.googleapis.com/oauth2/v4/token", "iat":'+ KJUR.jws.IntDate.get("now")+', "exp": '+KJUR.jws.IntDate.get("now + 1hour") +'}'
	    // console.log("claimSet:" + claimSet);
	    var privateKey = "-----BEGIN PRIVATE KEY-----\nMIIEvgIBADANBgkqhkiG9w0BAQEFAASCBKgwggSkAgEAAoIBAQDKkGV9FX6iNtsf\nRRBhqiGU466hyavxn0X14In6j1HiK5Y55kTnSb53xOgCyBDpWGqtVU8B9umYsf+3\nAk/71eos3w9hQA72aLdWjvLpMGNjhwORPzfUyBqYpGPebulnUTJ8+2uS0rIRw5j9\nXyD11vyYmXNDfCCgv8/srzNYVNy0U2p5Wb3FB0NIY2a3B+VIPzbPHQnFMyk5RRCG\nzlWKbxRvyYXG7RwXSjY1b/AcOE0yg1uhGipTy0LXZaF4glamGCy3JMpdqF6mCbF3\nMcPDM+mxTCUsbnsffjaUSfwVDxZnmtP0/Y938J/aGedqb2dmb7C9EeKmDy2fOozs\nbx8kDd7JAgMBAAECggEAJdlMNU6OXlX8pH+dm3oUE0NlrnJFz/xwMIyXi3s7FBUL\n2V620jabwbpHlbl3O3qbWC7f9+CAblkYDESA2G/0dRTqxUOYaB9R3nkQV1UExSSF\nnJ6g2n/XRF03EelMcFMiKWs7AvCeeCZBkFo1iOn2Qbcua9YmLJMakUF9SQx2PrUg\nTvAVUzVDLE+imjHt1s4jQKKRkM82FEwY4bjyb3iWHA8MQ7sTJbw9Ce+DXCxhQHm+\nmD5dUpE5qgr1kuorlubz64cU/7+dBbE08bPhv5oB3Zr/K3Q5fNz5+ooWnmJTQwjd\nREhtzyHLLkroxkbZyqJegW2Z3uZ2fOQ72uXt0S4r9wKBgQDj2PfAxH/EPEkGYh7k\nO2fi9f7eovMf3h0xOH/mR5gwSCd8vU1QzvSh4jjIqLQijcYny/pEWOSL0r8N2Jbp\nemH8q2vdTsGHKUE9r4VKkLoGaRCqTAhhENrN6mDhLxhA+3FYDNWhTL4fHT32f4ZC\nuJWxt5JayE5p/vKaKJxRdEak6wKBgQDjl7AzhJPytMjAhaaoysegTgaij08fTovE\nIeAB+oQSZSJQ5RhOovvIsKbw2i3JOev6NNTbLwn0/MGYQgb9jdTWzM6KuLyd/ZPv\nOB5LkiqVPTJxaEb5eVIOz5oeyY36eGD2FjernUb2hK8OJnfgBnpG24R1TU8Xk2NZ\ntkVJ59juGwKBgQDiVAfmyEpSV8ACQz2EYS5U2R8PcLYpFa3R0tnZmYyniUUQN8qx\nVqLSm7DkQhCNsl7/8TLs6ZA9BF8cFeXyjsr+/hjrgOvkoypXaB7zbsgazgrr3xMD\nuIZgvUz24p0pD5wLZtReoajJp3aBgTOQ22J3Ym5TF14tFD9Qur5seyAheQKBgQDB\nDmMA0G1Pa9r+tGByvdAoQweNzVKok9ArRzDlfMObdv5s8Gh2C/rYekCh/fDoyKFL\nVJVad8RSdDUkGp4jZrQsoP5y3dHhksByI4BPSmWkwoyPdoz+AdOBjMiHZSFyXbqi\nBKakhH01j8eOkUMOXXBLutnZRwLYVMXpy5tq3ag+EQKBgCMXZXM3A2inSyDdicPK\n8UJzW6y5Cz/S5O+7TqELwrqMBpuexTwSCq7q1KvSkC6U1xfwE8ImepI0RyRYgpgl\nRRR2lAsiJZPAN0ckPZW5lgzgEtVBU1hr6fp8c6kA3TF1eHkquhfAaG4AngNlPCMX\nl0bW8SL3FTafWeMmmCtj/Anh\n-----END PRIVATE KEY-----\n";

	    var sHead = newline_toDos(header);
	    var head = KJUR.jws.JWS.readSafeJSONString(sHead);
	    var sPayload = newline_toDos(claimSet);
	    var sPemPrvKey = privateKey;

	    var jws = new KJUR.jws.JWS();
	    var sResult = null;
	    try {
	        prv = KEYUTIL.getKey(sPemPrvKey);

	        sResult = KJUR.jws.JWS.sign(head.alg, sHead, sPayload, prv);
	    } catch (ex) {
	        alert("Error: " + ex);
	    }
	    return sResult;
	}

	function requestAccessToken() {
	    
	    // console.log('Assertion: ' + assertion);
	     // console.log((KJUR.jws.IntDate.get("now") - self.cachedAccessToken.cacheTime) > 59 * 60);
	     // console.log("cacheTime" + self.cachedAccessToken.cacheTime);
	    if (self.cachedAccessToken.access_token == "" || (KJUR.jws.IntDate.get("now") - self.cachedAccessToken.cacheTime) > 59 * 60){
	    	// console.log("in if");
	    	var assertion = _genJWS();
	    	return $.ajax({
		        type: "POST",
		        url: "https://www.googleapis.com/oauth2/v4/token",
		        contentType: "application/x-www-form-urlencoded",
		        dataType: "json",
		        global: false,
		        data: "grant_type=urn%3Aietf%3Aparams%3Aoauth%3Agrant-type%3Ajwt-bearer&assertion=" + assertion
		    });
	    }
	    else{
	    	// console.log("in else");
	    	return {access_token: self.cachedAccessToken.access_token}
	    }
	   
	}
}